import { P } from 'base-components';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'lingui-react';
import {
  Container,
  Row,
  Column,
} from 'styled-components-reactive-grid';

import ServiceProviderSelectionStep from 'compositions/ServiceProviderSelectionStep';

import messages from './messages';

function ServiceProviderSelection({
  completeStep,
  inputData: {
    serviceProvider = { address: {} },
    assetLocationSearchValue,
  },
  inputData,
  review,
}) {
  if (review) {
    const {
      address: {
        city,
        postalCode,
        region,
        street,
        street2,
      },
      companyName,
    } = serviceProvider;
    return (
      <Container className="service-provider-selection-review">
        <Row>
          <Column modifiers={['col_3']}>
            <P modifiers={['fontWeightMedium']}>
              <Trans id={messages.serviceProvider} />
            </P>
          </Column>
          <Column modifiers={['col_9']}>
            <P modifiers={['fontWeightRegular']}>
              {assetLocationSearchValue}
            </P>
            <P modifiers={['fontWeightRegular']}>
              {companyName}
            </P>
            <P modifiers={['fontWeightRegular']}>
              {`${street} ${street2}`}
            </P>
            <P modifiers={['fontWeightRegular']}>
              {`${city}, ${region} ${postalCode}`}
            </P>
          </Column>
        </Row>
      </Container>
    );
  }

  return (
    <ServiceProviderSelectionStep
      inputData={inputData}
      completeStep={completeStep}
    />
  );
}

ServiceProviderSelection.propTypes = {
  completeStep: PropTypes.func.isRequired,
  inputData: PropTypes.shape({
    serviceProvider: PropTypes.shape({
      companyName: PropTypes.string.isRequired,
    }),
    assetLocationSearchValue: PropTypes.string,
  }),
  review: PropTypes.bool,
};

ServiceProviderSelection.defaultProps = {
  inputData: {},
  review: false,
};

export default ServiceProviderSelection;



// WEBPACK FOOTER //
// ./components/WizardSteps/ServiceProviderSelection/index.js